import { render, staticRenderFns } from "./FmxWrapper.vue?vue&type=template&id=2db324c6&"
import script from "./FmxWrapper.vue?vue&type=script&lang=js&"
export * from "./FmxWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports